export const currencyFormarter = (data) => {
    // console.log('DATA FROM CURRENCY FORMARTER GET: ', data)
    return (data.amount).toLocaleString( data.currency ?? 'en', {
        style: 'currency',
        currency: data.currency ?? 'USD'
    })
}